/*
 *		Copyright (c) 2011-2021 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Nodes')
    .directive('accViewEsignatureDetails', ['EsignatureDetailsModal', function (EsignatureDetailsModal) {
        return {
            replace: true,
            transclude: true,
            template: ' <a href ng-click="viewEsignatureDetails()" ng-transclude></a>',
            scope: {
                esignature: '<'
            },
            link: function ($scope) {
                $scope.viewEsignatureDetails = function () {
                    EsignatureDetailsModal.open($scope.esignature);
                }
            }
        }
    }]);
